__turbopack_context__.v({
  "checkboxBox": "Checkbox-module-scss-module__r3xp9W__checkboxBox",
  "checked": "Checkbox-module-scss-module__r3xp9W__checked",
  "checkmark": "Checkbox-module-scss-module__r3xp9W__checkmark",
  "checkmarkAppear": "Checkbox-module-scss-module__r3xp9W__checkmarkAppear",
  "disabled": "Checkbox-module-scss-module__r3xp9W__disabled",
  "input": "Checkbox-module-scss-module__r3xp9W__input",
  "label": "Checkbox-module-scss-module__r3xp9W__label",
  "wrapper": "Checkbox-module-scss-module__r3xp9W__wrapper",
});
